import _extends from "@babel/runtime/helpers/extends";
import * as Link from './base';
export default _extends({}, Link);